// extracted by mini-css-extract-plugin
export default {"AboutMeModal":"AboutMeModal_AboutMeModal__rTtBq","aboutMeDiv":"AboutMeModal_aboutMeDiv__f-SWS","imagesContainer":"AboutMeModal_imagesContainer__c12q2"};